const errorFieldsMap = {
  'phone': 'phoneError',
  'email': 'emailError',
  'name': 'nameError',
  'placeId': 'placeError',
  'displayName': 'displayNameError',
  'code': 'codeError',
  'mobile': 'mobileError',
  'offer.truckNumber': 'truckNoError',
  'offer.driver.preferredContact': 'driverNoError',
  'file': 'bannerImage',
  'truckNumber': 'truckNoError',
  'loadingDate': 'loadingDateError',
}

// True when the property has an inline error slot, so a toast would only repeat it
export const hasInlineFieldError = (property: string) => property in errorFieldsMap

export const setFieldError = (errorStoreState: any, firstErrorField: string, errorMessage: string) => {
  const fieldProperty = errorFieldsMap[firstErrorField]

  if (fieldProperty)
    errorStoreState[fieldProperty] = errorMessage
}

export const setFieldsErrors = (errorStoreState: any, errors: any) => {
  errors.forEach((error: any) => {
    setFieldError(errorStoreState, error.property, error.errors[0])
  })
}
